import React from 'react';
export const Hero = () => {
  return <header className="mb-10" data-id="element-116" data-mp="3q74m9ffp662i">
      <h1 className="text-3xl sm:text-4xl md:text-5xl tracking-tight text-gray-900 leading-tight mb-5 font-[700]" data-id="element-117" data-mp="ejwib60ji54o">
        Wake Up Without Immediately Thinking About Your Neck
      </h1>
      <p className="text-xl text-gray-600 mb-6 italic leading-relaxed" data-id="element-118" data-mp="9igx9dyd3yma">
        Stop waking up stiff, sore, and searching for relief. Discover the
        cervical support design helping thousands sleep in better alignment and
        wake up feeling more refreshed.
      </p>
      <div className="flex items-center text-sm text-gray-500 mb-8 border-y border-gray-200 py-3" data-id="element-119" data-mp="xaxityhb68qc">
        <img src="https://i.pravatar.cc/100?img=5" alt="Author" className="w-10 h-10 rounded-full mr-3" data-id="element-120" data-mp="s9qa9x7cd5im" />
        <div data-id="element-121" data-mp="3d1a99mbhsfec">
          <div className="font-semibold text-gray-800" data-id="element-122" data-mp="3d1scx40hhvwa">By Sarah Jenkins</div>
          <div data-id="element-123" data-mp="382fhvvzgliim">Published January 13 • 5 min read</div>
        </div>
      </div>
      <figure className="mb-8" data-id="element-124" data-mp="384jtz17ihntz">
        <img src="https://cdn.magicpatterns.com/uploads/gZHSGikppCxSSSjP2u8n6G/Hero_Section.jpg" alt="Premium Cervical Pillow" className="w-full rounded-sm object-cover" data-id="element-125" data-mp="3j7zfnjujfuh7" />
        <figcaption className="text-sm text-gray-500 mt-3 text-center" data-id="element-126" data-mp="39b4ip5dwy251">
          Proper cervical support can drastically change how you feel every
          morning.
        </figcaption>
      </figure>
    </header>;
};